module.exports = __webpack_public_path__ + "static/img/2_1_2.9b0ba6e7.jpg";